module.exports = __webpack_public_path__ + "static/logo-f1e2069ebdde58bbaf3a7c93444b090c.png";